import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider } from "@/context/AdminAuth";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import Home from "@/pages/Home";
import Careers from "@/pages/Careers";

function App() {
  return (
    <AdminAuthProvider>
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/careers" element={<Careers />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#112E1E",
                color: "#FBFBF9",
                border: "1px solid rgba(217,119,36,0.4)",
              },
            }}
          />
        </SmoothScroll>
      </BrowserRouter>
    </AdminAuthProvider>
  );
}

export default App;
